import {defineStore} from 'pinia'
import axios from "axios";
import Utility from "../vue/Utility";

export const useWishlistStore = defineStore('WishlistStore', {
    persist: true,
    state: () => ({
        wishlistCount: 0,
        wishes: [],
        productIds: []
    }),

    actions: {
        async addToWishlist(productId) {
            try {
                let r = await axios
                    .post('/wishlist/add', {
                            productId: productId
                        }
                    )

                this.setWishlistDataFromServer(r.data)
            } catch (error) {
                Utility.catchError(error)
            }
        },

        async removeFromWishlist(productId) {
            try {
                let r = await axios
                    .post('/wishlist/remove', {
                            productId: productId
                        }
                    );

                this.setWishlistCount(r.data.count)
                this.setWishes(r.data.wishes)
                this.setProductIds(r.data.productIds)
            } catch (error) {
                Utility.catchError(error)
            }
        },

        setWishlistDataFromServer(data) {
            this.setWishlistCount(data.count)
            this.setWishes(data.wishes)
            this.setProductIds(data.productIds)
        },

        setWishlistCount(value) {
            this.wishlistCount = value
        },

        setWishes(value) {
            this.wishes = value
        },

        setProductIds(value) {
            this.productIds = value
        }

    }
})
